import { Avatar, Card, Skeleton, Space, Typography } from "antd";
import { CorpDetailAPIEntity } from "../../../../../serviceoperation/entity/CorporationOperationEntity";
import { Building2, Globe, Calendar } from "lucide-react";
import { useToken } from "@ant-design/pro-components";

interface OrganizationOverviewProps {
  organization?: CorpDetailAPIEntity;
  loading: boolean;
}

const OrganizationOverview: React.FC<OrganizationOverviewProps> = ({
  organization,
  loading,
}) => {
  const { Title, Text } = Typography;
  const { token } = useToken();

  return (
    <Card>
      {loading ? (
        <Skeleton loading={loading} active />
      ) : (
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <Avatar
              size={64}
              icon={<Building2 size={32} />}
              style={{ backgroundColor: token.colorPrimary }}
            />
            <div>
              <Title level={4} style={{ margin: 0 }}>
                {organization?.name}
              </Title>
              <Text type="secondary">{organization?.description}</Text>
            </div>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 16,
            }}
          >
            <div>
              <Space>
                <Globe size={16} />
                <div>
                  <Text type="secondary">Headquarters</Text>
                  <div>{`${organization?.address?.city} , ${organization?.address?.state}`}</div>
                </div>
              </Space>
            </div>

            <div>
              <Space>
                <Calendar size={16} />
                <div>
                  <Text type="secondary">Created</Text>
                  <div>
                    {new Date(
                      organization!.createdDateUTC
                    ).toLocaleDateString()}
                  </div>
                </div>
              </Space>
            </div>

            <div>
              <Text type="secondary">Website</Text>
              <div>
                <a
                  href={`${organization?.website}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1890ff" }}
                >
                  {organization?.name}
                </a>
              </div>
            </div>
          </div>
        </Space>
      )}
    </Card>
  );
};

export default OrganizationOverview;
